module.exports = __webpack_public_path__ + "static/media/food-chain_hero_desktop.8c310466.jpg";